import React from "react";
import { useDebouncedCallback } from "use-debounce";

import {
  Box,
  TextField,
  FormControl,
  InputAdornment,
  InputLabel,
  Input,
  IconButton,
  Button,
  Typography,
  Select,
  MenuItem,
  FormHelperText,
  Alert,
  Tabs,
  Tab,
} from "@mui/material";
import {
  AccountCircleOutlined,
  Visibility,
  VisibilityOff,
  LockOutlined,
  Group,
} from "@mui/icons-material";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { set } from "lodash";
import { Grid } from "../../../components/table";
import { CONFIG } from "../../../../config";
import axios from "axios";
import { ToolBar } from "../../../components/toolbar";
import { Modal } from "../../../components/modal";
import { FormA } from "../../../components/form";
import moment from "moment";
import { getFormState } from "../../../../helpers/form";
import dayjs from "dayjs";
import IosShareIcon from "@mui/icons-material/IosShare";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import Menu from "@mui/material/Menu";
import { filterColumns } from "../column-manager";

const API_HOST = CONFIG.modules["accounts"].host;
const API_HOST_CRM = CONFIG.modules["crm"].host;

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 1 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

// month filters
// weired naming
const monthFiltersArray = [
  "One",
  "Second",
  "Third",
  "Fourth",
  "fifth",
  "Sixth",
  "Seventh",
  "Eighth",
  "Ninth",
  "Delivered",
];

const monthFilters = monthFiltersArray.map((m) => {
  return {
    _id: m,
    name: m,
  };
});

// trimester
const trimesterArray = ["First", "Second", "Third", "Delivered"];

const trimesterFilter = trimesterArray.map((m) => {
  return {
    _id: m,
    name: m,
  };
});

export const ConnectedDebug = (props) => {
  const {
    roles,
    user,
    users,
    Designations,
    Departments,
    Languages,
    Districts,
    map,
  } = useSelector((state) => state.user || {});
  const history = useHistory();
  const [data, setData] = useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);
  const [selected, setSelected] = React.useState();
  const [selectedRows, setSelectedRows] = useState([]);
  const [creating, setCreating] = useState(false);
  const [createCompleted, setCreateCompleted] = useState(false);
  const [remainingFollowups,setRemainingFollowups] = useState(null);
  const [totalMother, setTotalMother] = useState(null);
  const [cycleCompleted, setCycleCompleted] = useState(0);

  const [count, setCount] = useState(0);
  const [filter, setFilter] = useState({
    from: null,
    to: null,
  });

  const debounced = useDebouncedCallback(
    (value) => {
      setFilter({ ...value });
    },
    1000
  );

  const toolbarButtons = [
    // {
    //     name: 'Manual Assign',
    //     icon: () => <IosShareIcon sx={{ fontSize: '1.2em' }} />,
    //     onClick: () => {
    //         // exportReport(new Date())
    //         // history.push('/lead/call-data/reports/QualityAssurance')
    //     },
    //     // isDisabled: false
    // },
    // {
    //     name: 'Add to Quality Assurance',
    //     icon: () => <IosShareIcon sx={{ fontSize: '1.2em' }} />,
    //     onClick: () => {
    //         // exportReport(new Date())
    //     },
    //     // isDisabled: false
    // },
    // {
    //     name: 'Download Report',
    //     icon: () => <IosShareIcon sx={{ fontSize: '1.2em' }} />,
    //     onClick: () => {
    //         // exportReport(new Date())
    //     },
    //     // isDisabled: false
    // },
    {
      name: createCompleted ? 'Follow up completed' : creating ? 'Creating followup casses.....' : `Create Followup Calls`,
      // type: 'chip',
      icon: () => <IosShareIcon sx={{ fontSize: "1.2em" }} />,
      onClick: () => {
        if(!creating) {
          createCases()
        }
      },
    },
    {
      name: `Export ${selectedRows.length ? `(${selectedRows.length})` : 'all'}`,
      // type: 'chip',
      icon: () => <IosShareIcon sx={{ fontSize: "1.2em" }} />,
      onClick: () => {
        exportReport(new Date());
      },
    },
    {
      name: "Today",
      // type: 'chip',
      // icon: () => <IosShareIcon sx={{ fontSize: '1.2em' }} />,
      onClick: () => {
        setFilter({ ...filter, from: dayjs(), to: dayjs() });
      },
    },
    {
      name: "This week",
      // type: 'chip',
      // icon: () => <IosShareIcon sx={{ fontSize: '1.2em' }} />,
      onClick: () => {
        const start = dayjs().weekday(-7);
        const end = start.add(6, "day");
        // console.log(start.format('DD-MM-YYYY'), end.format('DD-MM-YYYY'))
        setFilter({ ...filter, from: start, to: end });
      },
    },
  ];

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const filterString = (filter) => {
    let queryString = "";
    if (filter.motherID) {
      queryString += `&motherID=${filter.motherID}`;
    }
    if (filter._id) {
        queryString += `&_id=${filter._id}`;
      }

    if (filter.bName) {
      queryString += `&bName=${filter.bName}`;
    }

    if (filter.age) {
      queryString += `&age=${filter.age}`;
    }

    if (filter.week) {

      queryString += `&week=${filter.week}`;
    }

    if (filter.pregnancyMonth) {

      // queryString += `&pregnancyMonth=${filter.pregnancyMonth}`;
      queryString += `&pregnancyMonth=${encodeURIComponent(JSON.stringify(filter.pregnancyMonth))}`;
    }

    if (filter.trimester) {

      // queryString += `&trimester=${filter.trimester}`;
      queryString += `&trimester=${encodeURIComponent(JSON.stringify(filter.trimester))}`;
    }

    if (filter.pregnancyStatus) {

      // queryString += `&pregnancyStatus=${filter.pregnancyStatus}`;
      queryString += `&pregnancyStatus=${encodeURIComponent(JSON.stringify(filter.pregnancyStatus))}`;
    }

    if (filter.district) {
      queryString += `&district=${encodeURIComponent(JSON.stringify(filter.district))}`;
    }

    if (filter.agent) {

      queryString += `&agent=${encodeURIComponent(JSON.stringify(filter.agent))}`;
    }

    if (filter.cluster) {

      queryString += `&cluster=${filter.cluster}`;
    }

    if (filter.dataType) {

      // queryString += `&dataType=${filter.dataType}`;
      queryString += `&dataType=${encodeURIComponent(JSON.stringify(filter.dataType))}`;
    }

    if (filter.childDeliveryPlace) {

      // queryString += `&childDeliveryPlace=${filter.childDeliveryPlace}`;
      queryString += `&childDeliveryPlace=${encodeURIComponent(JSON.stringify(filter.childDeliveryPlace))}`;
    }

    if (filter.homeDeliverReason) {

      // queryString += `&homeDeliverReason=${filter.homeDeliverReason}`;
      queryString += `&homeDeliverReason=${encodeURIComponent(JSON.stringify(filter.homeDeliverReason))}`;
    }

    if (filter.childImmunization) {

      // queryString += `&childImmunization=${filter.childImmunization}`;
      queryString += `&childImmunization=${encodeURIComponent(JSON.stringify(filter.childImmunization))}`;
    }

    if (filter.nonImmunizedReason) {

      // queryString += `&nonImmunizedReason=${filter.nonImmunizedReason}`;
      queryString += `&nonImmunizedReason=${encodeURIComponent(JSON.stringify(filter.nonImmunizedReason))}`;
    }

    if (filter.highRisk) {

      // queryString += `&highRisk=${filter.highRisk}`;
      queryString += `&highRisk=${encodeURIComponent(JSON.stringify(filter.highRisk))}`;
    }

    if (filter.lessThen1Year) {

      // queryString += `&lessThen1Year=${filter.lessThen1Year}`;
      queryString += `&lessThen1Year=${encodeURIComponent(JSON.stringify(filter.lessThen1Year))}`;
    }

    if (filter.between1And2) {

      // queryString += `&between1And2=${filter.between1And2}`;
      queryString += `&between1And2=${encodeURIComponent(JSON.stringify(filter.between1And2))}`;
    }

    if (filter.advice) {
      queryString += `&advice=${filter.advice}`;
    }
    if (filter.callStatus) {
      // queryString += `&callStatus=${filter.callStatus}`;
      queryString += `&callStatus=${encodeURIComponent(JSON.stringify(filter.callStatus))}`;
    }

    return queryString;
  };

  const getReports = () => {
    const queryString = filterString(filter)
    axios
      .get(
        API_HOST_CRM +
        `/ecd-reports?limit=${rowsPerPage}&page=${page}&${filter.from ? `&from=${dayjs(filter.from).format("YYYY-MM-DD")}` : ""}` +
        `${filter.to ? `&to=${dayjs(filter.to).format("YYYY-MM-DD")}` : ""}` +
        `${queryString}`
      )
      .then((resp) => {
        if (resp.data && resp.data.success) {
          setData(resp.data.ecd);
          setCount(resp.data.count);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  useEffect(()=> {
    getReports();
  },[page, rowsPerPage])

  useEffect(() => {
    getReports();
  }, []);
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      getReports();
    }, 500)
    return () => {
      clearTimeout(timeoutId)
    }
  }, [filter]);

  useEffect(() => {
    // console.log('------------->', selectedRows.map(e => e._id))
  }, [selectedRows])

  useEffect(()=>{
    getRemainingFollowups()
  },[])

  const getRemainingFollowups = () => {
    axios
        .get(
          API_HOST_CRM + `/remaining-ecd-followup`
        )
        .then((resp) => {
          if (resp.data.success) {
            setCycleCompleted(resp.data.completed)
            setRemainingFollowups(resp.data.remainingFollowups)
            setTotalMother(resp.data.distinctMother)
          }
        })
        .catch((e) => {
          console.log(e);
        });
  }
  const exportReport = () => {
    const queryString = filterString(filter)
    if (true) {
      axios
        .get(
          API_HOST_CRM +
          `/ecd/export-all?&ids=${encodeURIComponent(JSON.stringify((selectedRows||[]).map(e => e._id)))}` +
          `${filter.from ? `&from=${dayjs(filter.from).format("YYYY-MM-DD")}` : ""}` +
          `${filter.to ? `&to=${dayjs(filter.to).format("YYYY-MM-DD")}` : ""}` +
          `${queryString}`,
          {
            responseType: "arraybuffer",
          }
        )
        .then((resp) => {
          if (resp) {
            const url = window.URL.createObjectURL(new Blob([resp.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
              "download",
              // `ECD_Report_${dayjs(filter.from).format("DD-MM-YYYY")}-${dayjs(
              //   filter.to
              // ).format("DD-MM-YYYY")}.xlsx`
              `ECD_Report_${dayjs().format("DD-MM-YYYY HH:mm:ss")}.xlsx`
            );
            document.body.appendChild(link);
            link.click();
            console.log(resp);
            link.remove();
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }

  };

  const createCases = () => {
    setCreating(true)
    axios
      .get(API_HOST_CRM + "/create-auto")
      .then((resp) => {
        if (resp.data && resp.data.success) {
          setCreating(false)
          setCreateCompleted(true)
          getRemainingFollowups()
          setTimeout(() => {
            setCreateCompleted(false);
          }, 2000);
        }
        setCreating(false)
      })
      .catch((e) => {
        console.log(e);
        setCreating(false)
      });
  }


  return (
    <>
    <Box sx={{mt:5, display:'flex'}}>

    <h5 >Remaining followups: {remainingFollowups||0}</h5> &nbsp; &nbsp;&nbsp; <h5 >Cycle Completed: {cycleCompleted ||0}</h5>
    &nbsp; &nbsp;&nbsp; <h5 >Total Mothers: {totalMother ||0}
    </h5>
    </Box>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <ToolBar
          name={""}
          buttons={toolbarButtons}
          open={open}
          flex={"column"}
          height={"100%"}
          handleClose={handleClose}
          anchorEl={anchorEl}
          filters={[
            {
              field: {
                name: "from",
                type: "date",
                label: "From",
              },
              onChange: (name, value) => {
                filter[name] = value;
                setFilter({ ...filter });
              },
              state: filter,
            },
            {
              field: {
                name: "to",
                type: "date",
                label: "To",
              },
              onChange: (name, value) => {
                filter[name] = value;
                setFilter({ ...filter });
              },
              state: filter,
            },
          ]}
        />
        <Box sx={{ mt: 2 }}>
          <Grid
            data={data}
            columns={[
              ...filterColumns([
                {
                    id: "_id",
                    showFilter: "true",
                    minWidth: 150
                  },
                {
                  id: "motherID",
                  showFilter: "true",
                  minWidth: 150
                },
                { id: "bName", label: "Name", minWidth: 70, showFilter: true },
                { id: "age", label: "Age", minWidth: 100, showFilter: true },
                { id: "week", label: "Week", minWidth: 100, showFilter: true },
                { id: "pregnancyMonth", label: "Month", minWidth: 100, showFilter: true, type: "select" },
                { id: "trimester", label: "Trimester", minWidth: 100, showFilter: true, type: "select" },
                {
                  id: "pregnancyStatus",
                  label: "Pregnancy Status",
                  minWidth: 200,
                  showFilter: true,
                  type: "select",
                },
                { id: "district", label: "District", minWidth: 150, showFilter: true, type: "select" },
                {
                  id: "agent",
                  label: "Caller",
                  minWidth: 100,
                  showFilter: true,
                  format: (data, row) => {
                    if (map.users) {
                      return map.users?.[data]?.name || data;
                    }
                    return data;
                  },
                },
                { id: "cluster", label: "Cluster", minWidth: 150, showFilter: true },
                { id: "dataType", label: "Data Type", minWidth: 150, showFilter: true, type: "select" },
                { id: "callStatus", label: "Status", minWidth: 150, showFilter: true, type: "select" },
                {
                  id: "trimester",
                  label: "Trimester of Pregnancy",
                  minWidth: 150,
                  showFilter: true,
                  type: "select"
                },
                {
                  id: "childDeliveryPlace",
                  label: "Place of Child being Delivered",
                  minWidth: 200,
                  showFilter: true,
                  type: "select"
                },
                {
                  id: "homeDeliverReason",
                  label: "If Delivered at home, what was the reason?",
                  minWidth: 200,
                  showFilter: true,
                  type: "select"
                },
                {
                  id: "childImmunization",
                  label: "Has the child been immunized?",
                  minWidth: 200,
                  showFilter: true,
                  type: "select"
                },
                {
                  id: "nonImmunizedReason",
                  label:
                    "If the child has not been immunized, what was the reason?",
                  minWidth: 200,
                  showFilter: true,
                  type: "select"
                },
                {
                  id: "highRisk",
                  label: "Is the pregnancy a high risk?",
                  minWidth: 150,
                  showFilter: true,
                  type: "select"
                },
                {
                  id: "lessThen1Year",
                  label: "Children under 1 year",
                  minWidth: 150,
                  type: "select",
                  showFilter: true
                },
                {
                  id: "between1And2",
                  label: "Child from 1 - 2 Year old?",
                  minWidth: 150,
                  showFilter: true,
                  type: "select"
                },
                {
                  id: "advice",
                  label: "Advice",
                  minWidth: 150,
                  format: (data, row) => {
                    return (data || "").substring(0, 30);
                  },
                  showFilter: true
                },
              ], filter, setFilter, { Districts, users, map }),

              {
                id: "callDate",
                label: "Call Date",
                minWidth: 70,
                format: (data, row) => {
                  return data ? dayjs(data).format("DD-MM-YYYY") : "";
                },
              },
              // { id: 'callerType', label: 'Call Type', minWidth: 50 },

              // { id: 'sankalpId', label: 'Sankalp Data', minWidth: 50, format: (data, row) => {
              //     if(data) {
              //         return (<Button onClick={() => {
              //             setOpen(true)
              //             setSelectedSankalpData(data)
              //         }}>View</Button>)
              //     } else {
              //         return ''
              //     }
              // } },
            ]}
            pagination={{
              rowsPerPageOptions: [10, 25, 50],
              page,
              rowsPerPage,
              onPageChange: (event, newPage) => {
                setPage(newPage);
              },
              onRowsPerPageChange: (event) => {
                setRowsPerPage(+event.target.value);
                setPage(0);
              },
              count,
            }}
            onSelectChange={(selected) => {
              setSelectedRows([...selected]);
            }}
          ></Grid>
        </Box>
      </Box>
    </>
  );
};
